import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { TankIcon } from 'app/agriculture/icons';
import { Skeleton } from '@mui/material';
import { ContentBoxSkeleton } from 'app/agriculture/components/ContentBox/ContentBoxSkeleton';
import { TankLevelSkeleton } from 'app/agriculture/infobox/common/TankLevelSkeleton';
import { SkeletonLineChart } from 'app/agriculture/charts/SkeletonLineChart/SkeletonLineChart';
import { NotesForEntitySkeleton } from 'app/agriculture/infobox/notes/NotesForEntitySkeleton';
import { TasksForEntitySkeleton } from 'app/agriculture/infobox/tasks/TasksForEntity/TasksForEntitySkeleton';

export function TankDetailsSkeleton() {
    return (
        <ContentBoxSkeleton className="TankDetailsComponent" Icon={TankIcon} variant="lg">
            <ContentBox.Section scrollable>
                <TankLevelSkeleton />
                <ContentBox.Section>
                    <SimpleGrid columns={3}>
                        <StatDisplay
                            id="tank-volume"
                            name="Capacity"
                            value={<Skeleton variant="text" width={80} />}
                            unit="L"
                        />
                        <StatDisplay
                            id="tank-height"
                            name="Height"
                            value={<Skeleton variant="text" width={40} />}
                            unit="m"
                        />
                        <TasksForEntitySkeleton />
                    </SimpleGrid>
                </ContentBox.Section>
                <SkeletonLineChart title="Avg Level" />
                <NotesForEntitySkeleton />
            </ContentBox.Section>
        </ContentBoxSkeleton>
    );
}
